import React from 'react';

const WebBrowserFrame = ({ width = 1440, height = 900, url = 'design-preview.app', children, style }) => {
  const TITLEBAR_H = 38;

  return (
    <div style={{
      width, height: height + TITLEBAR_H,
      borderRadius: '10px 10px 4px 4px',
      overflow: 'hidden', display: 'flex', flexDirection: 'column', flexShrink: 0,
      boxShadow: '0 24px 64px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.08)',
      ...style,
    }}>
      {/* Title bar */}
      <div style={{
        height: TITLEBAR_H, background: '#E8E8E8',
        display: 'flex', alignItems: 'center', gap: 8, px: 12, flexShrink: 0,
        padding: '0 12px',
      }}>
        {/* Traffic light dots */}
        <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0 }}>
          <div style={{ width: 12, height: 12, borderRadius: '50%', background: '#ff5f57' }} />
          <div style={{ width: 12, height: 12, borderRadius: '50%', background: '#ffbd2e' }} />
          <div style={{ width: 12, height: 12, borderRadius: '50%', background: '#28c840' }} />
        </div>

        {/* URL bar */}
        <div style={{
          flex: 1, height: 22, background: '#fff', borderRadius: 4,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 11, color: '#666', fontFamily: '-apple-system, sans-serif',
          border: '1px solid #d0d0d0', maxWidth: 360, mx: 'auto',
          margin: '0 auto',
        }}>
          🔒 {url}
        </div>

        {/* Spacer to balance the traffic lights */}
        <div style={{ width: 54, flexShrink: 0 }} />
      </div>

      {/* Page content */}
      <div style={{ flex: 1, background: '#fff', overflow: 'hidden' }}>
        {children}
      </div>
    </div>
  );
};

export default WebBrowserFrame;
